function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m93.8 49.7c0 3.5-2.8 6.3-6.3 6.3s-6.4-2.8-6.4-6.3 2.8-6.3 6.4-6.3c3.5-.1 6.3 2.8 6.3 6.3zm25-3.9v7h-10.5c-1.9 27.9-25.2 50.1-53.6 50.1-24.7 0-46.1-16.7-52.1-40.7-.9-3.7-1.4-7.5-1.5-11.3-.1-.5-.1-1-.1-1.6 0-.1 0-.1 0-.2v-3.5h44.2c2-16.2 15.2-28.6 31-28.6h.6c17.5.3 30.1 12 31.6 28.8zm-91.6 22.7c9 0 16-6.6 17.5-15.8h-36.4c1.6 8.9 9.5 15.8 18.9 15.8zm74.3-19.3c0-17-12.5-24.9-24.8-25.1-13.3-.3-24.4 11-24.7 25.2l-.1 3.4h-.1c-1.5 13.3-11.6 22.9-24.6 22.9-4.9 0-9.4-1.3-13.3-3.6 8.1 14.6 23.5 24 40.9 24 25.7-.1 46.7-21.1 46.7-46.8z",
  fill: "#015168",
  fillRule: "evenodd"
});

var SvgLintujenTarkkailu = function SvgLintujenTarkkailu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 120 120",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLintujenTarkkailu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lintujen-tarkkailu.131f1e3a.svg";
export { ForwardRef as ReactComponent };